import { render, staticRenderFns } from "./AdminReportBrandsHealthScoring.vue?vue&type=template&id=82e80c66&scoped=true"
import script from "./AdminReportBrandsHealthScoring.vue?vue&type=script&lang=js"
export * from "./AdminReportBrandsHealthScoring.vue?vue&type=script&lang=js"
import style0 from "./AdminReportBrandsHealthScoring.vue?vue&type=style&index=0&id=82e80c66&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e80c66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82e80c66')) {
      api.createRecord('82e80c66', component.options)
    } else {
      api.reload('82e80c66', component.options)
    }
    module.hot.accept("./AdminReportBrandsHealthScoring.vue?vue&type=template&id=82e80c66&scoped=true", function () {
      api.rerender('82e80c66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminReportBrandsHealthScoring.vue"
export default component.exports